import Placeholder from '../components/Placeholder';

function AccountingPlaceholder() {
  const title = 'Accounting';
  const description = 'This section is being developed to provide financial tools, utilities, and reporting resources that support business operations accross the organization.'
  const features = [
    'Financial reporting tools',
    'Data conversion and processing utilities',
    'Operational cost analysis resources',
    'Accounting support applications',
  ]
  const benefits = ''

  return (
    <Placeholder
      title={title}
      description={description}
      features={features}
      benefits={benefits}
    />
  )
}

export default AccountingPlaceholder;